<template>
  <div class="pdf-preview">
    <div class="preview-container">
      <iframe :src="src" class="pdf-iframe" frameborder="0"></iframe>

      <div class="controls">
        <v-btn @click="download" fab x-small color="white" title="Descargar imagen" elevation="2">
          <v-icon>mdi-download</v-icon>
        </v-btn>

        <v-btn @click="dialog = true" fab x-small color="white" title="Abrir en pantalla completa" elevation="2">
          <v-icon>mdi-fullscreen</v-icon>
        </v-btn>
      </div>
    </div>

    <v-dialog v-model="dialog" hide-overlay max-width="1000" class="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark color="primary">
          <v-toolbar-title>Vista del PDF</v-toolbar-title>

          <v-spacer></v-spacer>

          <v-btn icon dark @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text class="pa-0">
          <iframe :src="src" class="pdf-iframe-fullscreen" frameborder="0"></iframe>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'PdfPreview',
  props: {
    src: {
      type: String,
      required: true,
    },
    nombreArchivo: {
      type: String,
      default: 'documento',
    },
  },
  data() {
    return {
      dialog: false,
    };
  },
  methods: {
    download() {
      const link = document.createElement('a');
      link.href = this.src;
      link.download = `${this.nombreArchivo}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
  },
};
</script>

<style scoped>
.pdf-preview {
  width: 100%;
  height: 340px;
}

.preview-container {
  position: relative;
  width: 100%;
  height: 100%;
}

.pdf-iframe {
  width: 100%;
  height: 100%;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
}

.floating-btn {
  position: absolute;
  bottom: 16px;
  right: 16px;
  z-index: 1;
}

.pdf-iframe-fullscreen {
  width: 100%;
  height: calc(100vh - 180px);
}

.controls {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 10px;
  background: rgba(0, 0, 0, 0.7);
  padding: 10px;
  border-radius: 8px;
}
</style>